<template>
    <div class="wrap">
        <my-layout :customize="customize" @gohome="gohome">
            <template #navbar><slot name="navbar"></slot></template>
            <template #personalSettingMiddleForm><slot name="personalSettingMiddleForm"></slot></template>
            <template #businessIconBox><slot name="businessIconBox"></slot></template>
            <template #mapIconBox><slot name="mapIconBox"></slot></template>
            <template #businessNavBarBox><slot name="businessNavBarBox"></slot></template>
            <template #mapNavBarBox><slot name="mapNavBarBox"></slot></template>
            <template #taggroupBreadcrumb><slot name="taggroupBreadcrumb"></slot></template>
            <template #personCenterIconBox><slot name="personCenterIconBox"></slot></template>
            <template #personCenterInfo><slot name="personCenterInfo"></slot></template>
            <template #customNavbar><slot name="customNavbar"></slot></template>
            <template #sidebarFooter><slot name="sidebarFooter"></slot></template>
        </my-layout>
    </div>
</template>

<script>
  import Global from '../../../utils/global';
  import Util from '../../../utils/util';
  import Auth from '../../../utils/auth';
  // import Vue from 'vue';
  // import VerticalMode from './VerticalMode';
  // import MyLayout from './HorizontalMode';
  import {onMessage} from '../../../utils/event-bus';
  import Constants from '../../../utils/constants';
  import {defineAsyncComponent} from '@vue/composition-api';

  export default {
    name: 'KiafLayout',
	components: {
      // VerticalMode,
      //   MyLayout
    },
    data(){
      return {
        selectText: '',
        selecting: false
      };
    },
    props: {
      mode: {
        type: String,
        default: 'horizontal'
      },
      customize: {
        type: Object,
        default(){
          return {};
        }
      }
    },
    created(){
      if(this.mode === 'vertical'){
          this.$global.getVue().component('MyLayout', defineAsyncComponent(() => import('./VerticalMode/index')));
      } else {
          this.$global.getVue().component('MyLayout', defineAsyncComponent(() => import('./HorizontalMode/index')));
      }
      onMessage(Constants.EVENT_BUS_CODE_CHANGE_THEME, (data) => {
        Util.setTheme(data.type, true);
      }, this);
      if(!Util.isWindowMap()){
        onMessage(Constants.EVENT_BUS_CODE_NEXT_ROUTE, (data) => {
          this.$store.commit('KIAF_INIT_WEBVIEW', {});
          if(data.path){
            if(data.path.indexOf('http') == 0){
              let url = data.path;
              if(data.webview){
                if(url.indexOf('?') >= 0){
                  url += '&webview_mode=' + data.webview;
                } else {
                  url += '?webview_mode=' + data.webview;
                }
              }
              location.href = url;
            } else {
              this.$router.push(data);
            }
          }
        }, this);
      }
      this.initRouter();
    },
    mounted(){
      this.init();
      this.initContextMenu();
    },
    watch: {   //监听路由变化
      $route(to, from) {
        this.removeContextMenu();
        this.initRouter();
      },
      'customize.selectText.hideAll'(to, from) {
         this.init();
      }
    },
    beforeDestroy() {
      document.body.onmouseup = null;
      document.removeEventListener('click', () => {});
      document.oncontextmenu = null;
    },
    methods: {
      init(){
        if(this.customize.selectText && !this.customize.selectText.hideAll){
          document.body.onmouseup = (e) => {
            let result = this.getSelectedText();
            if(!Util.isEmpty(result.selectText) && result.selectText != this.selectText){ //免鼠标事件响应的是同一个
              this.selectText = result.selectText;
              this.selecting = true;
              e.preventDefault();
              if(Util.isEmpty(result.selectText.trim())){
                return false;
              }
              this.initLayoutContextMenu(e, result, 'copy');
            };
          };
        }
      },
      initRouter(){
        if(Global.isAppPortalWebview()){
          // console.log('location.href>>>', location.href);
          if(location.href.indexOf('jwt_token') >= 0 && location.href.indexOf('webview_mode=internal') < 0){ // webview_mode用来区分tag，对于tag不做处理
            let path = this.$route.path;
            let fullPath = this.$route.fullPath;
            if(fullPath.indexOf('append_params') > 0){
              let fullPath = this.$route.fullPath;
              path = fullPath.split('append_params')[0];
            }
            if(location.href.indexOf('/kiaf/internalPage') >= 0){
              path += '?v=' + new Date().getTime();
              // Global.setInternalPage(Util.getUrlParam('internal_page'));
              // Global.setInternalPageTitle(Util.getUrlParam('app_portal_target'));
              // console.log('location.href>>>internal_page:', decodeURIComponent(Global.getInternalPage()));
              let webviewPage = {
                id: new Date().getTime(),
                title: decodeURIComponent(Util.getUrlParam('app_portal_target')),
                url: decodeURIComponent(Util.getUrlParam('internal_page'))
              };
              // Global.addStorage(Constants.STORAGE_KEY_WEBVIEW_PAGE, webviewPage);
              sessionStorage.setItem(Constants.STORAGE_KEY_WEBVIEW_PAGE, JSON.stringify(webviewPage));
            } else {
              this.$store.commit('KIAF_INIT_WEBVIEW', {});
            }
            this.$router.push({path: path});
          }
        }
      },
      gohome(val){
        this.$emit('gohome', val);
      },
      removeContextMenu(){
        // console.log('removeContextMenu>>>');
        this.selectText = '';
        let contextmenu = document.getElementById('KiafLayoutContextMenu');
        if(contextmenu){
          contextmenu.style.display = 'none';
          document.body.removeChild(contextmenu);
        }
      },
      initContextMenu(){
        document.oncontextmenu = (ev) => {
          console.log('oncontextmenu>>>', ev);
          if(Global.getCustomConfig()['KIAF_WATERMARK_IMAGE'] && ev.srcElement && ev.srcElement.tagName && ev.srcElement.tagName.toUpperCase() === 'IMG' && ev.srcElement.className != 'kiafWatermarkImage'){ // 忽略kiafwatermarkimage
            ev.preventDefault();
            let params = {
              imgUrl: ev.srcElement.src,
              imgName: ev.srcElement.name
            };
            this.initLayoutContextMenu(ev, params, 'download');
          }
        };
        document.addEventListener('click', () => {
          if(!this.selecting){
            this.removeContextMenu();
          }else{
            this.selecting = false;
          }
        });
      },
      initLayoutContextMenu(e, params, action){
        let div = document.getElementById('KiafLayoutContextMenu');
        if(div){
          document.body.removeChild(div);
        }
        div = document.createElement('div');
        div.className = 'watermark-image-contextmenu';
        div.id = 'KiafLayoutContextMenu';
        let ul = document.createElement('ul');

        let x = params.x || e.clientX;
        let y = params.y || e.clientY;
        if(action === 'download'){
          let li = document.createElement('li');
          let a = document.createElement('a');
          a.innerText = '下载图片';
          a.onclick = () => {
            Auth.downloadWatermarkImage(params.imgUrl, params.imgName);
          };
          li.appendChild(a);
          ul.appendChild(li);
          if(this.customize.selectText && this.customize.selectText.handleSearchImage){
            let labels = [];
            if(Array.isArray(this.customize.selectText.labelSearchImage)){
              labels = this.customize.selectText.labelSearchImage;
            } else {
              labels.push(this.customize.selectText.labelSearchImage || '搜索图片');
            }
            labels.forEach(label => {
              let li2 = document.createElement('li');
              let a2 = document.createElement('a');
              a2.innerText = label;
              a2.onclick = () => {
                this.customize.selectText.handleSearchImage({type: 'image', label: label, value: params.imgUrl});
              };
              li2.appendChild(a2);
              ul.appendChild(li2);
            });
          }
        } else if(action === 'copy'){
          let li = document.createElement('li');
          let imgCopy = document.createElement('div');
          let labelCopy = document.createElement('div');
          labelCopy.className = 'label';
          imgCopy.className = 'imgCopy';
          labelCopy.innerText = this.customize.selectText.labelCopy || '复制';

          imgCopy.onclick = (e) => {
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
            this.selectText = '';
          };
          labelCopy.onclick = (e) => {
            imgCopy.click();
          };

          let imgAction = document.createElement('div');
          let labelAction = document.createElement('div');
          labelAction.className = 'label';
          imgAction.className = 'imgAction';
          labelAction.innerText = this.customize.selectText.labelAction || '一键搜';

          // imgAction.src = require('../../../static/images/icon-action.png');
          // imgAction.title = this.customize.selectText.labelAction || '一键搜';
          // imgAction.onmouseenter = () => {
          //   // imgAction.src = require('../../../static/images/icon-action-active.png');
          //   Util.addClass(labelAction, 'active');
          // };
          // imgAction.onmouseout = () => {
          //   // imgAction.src = require('../../../static/images/icon-action.png');
          //   Util.removeClass(labelAction, 'active');
          // };
          // labelAction.onmouseenter = () => {
          //   // imgAction.src = require('../../../static/images/icon-action-active.png');
          //   Util.addClass(labelAction, 'active');
          // };
          // labelAction.onmouseout = () => {
          //   // imgAction.src = require('../../../static/images/icon-action.png');
          //   Util.removeClass(labelAction, 'active');
          // };
          imgAction.onclick = (e) => {
            try {
              let kcModelClose = document.getElementsByClassName('kc-modal__close');
              for(let i = 0; i < kcModelClose.length; i++){
                let kcModel = kcModelClose[i].parentNode.parentNode.parentNode.parentNode;
                if(kcModelClose[i] && kcModel && kcModel.style.display != 'none'){
                  kcModelClose[i].click();
                }
              }
            }catch (e) {
              console.error('close kc modal>>>', e);
            }

            if(this.customize.selectText.handleSelectText){
                this.customize.selectText.handleSelectText({type: 'text', value: params.selectText});
            }
            window.getSelection().removeAllRanges();
            this.selectText = '';
          };
          labelAction.onclick = (e) => {
            imgAction.click();
          };

          let vLine = document.createElement('div');
          vLine.className = 'v-line';

          li.appendChild(imgAction);
          li.appendChild(labelAction);
          li.appendChild(vLine);
          li.appendChild(imgCopy);
          li.appendChild(labelCopy);

          y = y - 56;
          ul.appendChild(li);
        }


        div.appendChild(ul);


        let w = window.innerWidth;
        let h = window.innerHeight;
        div.style.left = Math.min(w - 200, x) + 'px';
        div.style.top = Math.min(h - 80, y) + 'px';
        // console.log('initLayoutContextMenu>>>', div);
        document.body.appendChild(div);
        div.style.display = 'block';
      },
      getSelectedText() {
        let result = {};
        if (window.getSelection) {
          if (window.getSelection().type === 'Range') {
            const range = window.getSelection().getRangeAt(0).cloneRange();
            let rect = range.getBoundingClientRect();
            result.x = rect.x + rect.width;
            result.y = rect.y;
          }
          result.selectText = window.getSelection().toString();
        } else if (document.selection) {
          result.selectText = document.selection.createRange().text;
        }
        return result;
      }
    }
  };
</script>
<style scoped>
    .wrap{
        width: 100%;
        height: 100%;
        padding: 0px;
        margin: 0px;
    }
</style>
